export default "__VITE_ASSET__CETeB5iM__"